import React from "react";

function CTALock() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.248"
      height="24.72"
      viewBox="0 0 22.248 24.72"
    >
      <path
        id="Path_22411"
        data-name="Path 22411"
        d="M22.776,11.888h1.236a1.236,1.236,0,0,1,1.236,1.236v12.36a1.236,1.236,0,0,1-1.236,1.236H4.236A1.236,1.236,0,0,1,3,25.484V13.124a1.236,1.236,0,0,1,1.236-1.236H5.472V10.652a8.652,8.652,0,0,1,17.3,0Zm-2.472,0V10.652a6.18,6.18,0,0,0-12.36,0v1.236Zm-7.416,4.944v4.944H15.36V16.832Z"
        transform="translate(-3 -2)"
        fill="#fafafa"
      />
    </svg>
  );
}

export default CTALock;
